import { render, staticRenderFns } from "./myRobotUserKnowledge.vue?vue&type=template&id=3fa98401&"
import script from "./myRobotUserKnowledge.vue?vue&type=script&lang=js&"
export * from "./myRobotUserKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./myRobotUserKnowledge.vue?vue&type=style&index=0&id=3fa98401&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports